export const actionRewardConfigQueryKeys = {
  all: ['action-reward-configs'] as const,
  list: () => [...actionRewardConfigQueryKeys.all, 'list'] as const,
};
